import postAPI from './postAPI.js'

export default async function postReviewStep(body) {
    const data = await postAPI('admin/taskinstances/steps/review', body);
    return data;
}
